import styled from 'styled-components'

import ListItem from '../ListItem'
import Button from '../Button/Button'
import Link from '../Link/styled'

const MenuItem = styled(ListItem)`
  &,
  ${Button}, ${Link} {
    background-color: ${props => props.theme.colors[props.active ? 'primary' : 'white']};
    color: ${props => props.theme.fontColorWithBackground[props.active ? 'primary' : 'white']};
  }

  &:hover,
  &:hover ${Button}, &:hover ${Link} {
    background-color: ${props => (!props.active ? props.theme.colors.gray300 : '')};
    color: ${props => (!props.active ? props.theme.fontColorWithBackground.gray300 : '')};
  }

  ${Button}, ${Link} {
    padding-left: ${props => 12 * ((props.indent || 0) + 1)}px;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-items: flex-start;
    justify-content: flex-start;
    width: 100%;
    border: 0;
    border-radius: 0;
    text-decoration: none;

    font-weight: ${props => (props.heading ? 'bold' : 'normal')};

    white-space: nowrap;
  }
`

export default MenuItem
